// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"0bf5a467","931":"1d232f83"}[chunkId] + ".chunk.js";
};